<template>
  <el-form
    ref="form"
    class="auth-form"
    :model="form"
    :rules="rules"
    :label-position="labelPosition"
    :label-width="labelWidth"
  >
    <el-form-item
      label="授权码类型"
      prop="type"
    >
      <el-select
        style="width: 100%"
        popper-class = "specialSelect"
        @change = "typechange"
        placeholder="授权码类型"
        v-model="form.type"
        :disabled="isEdit"
      >
        <el-option
          v-for="(item,index) in authtypes"
          :key="index"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="授权产品"
      prop="productType"
    >
      <el-select
        style="width: 100%"
        popper-class = "specialSelect"
        placeholder="授权产品"
        v-model="productTypeProxy"
        :multiple="form.type !== 3"
        :key="'productSelect-' + form.type"
      >
        <el-option
          v-for="(item,index) in productList"
          :key="index"
          :label="`${item.productName} (${item.productCode})`"
          :value="item.id"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="form.type !== 3"
      label="客户姓名"
      prop="name"
    >
      <el-input
        v-model="form.name"
        placeholder="请输入"
      ></el-input>
    </el-form-item>
    <el-form-item
      v-if="form.type !== 3"
      label="手机"
      prop="phone"
    >
      <el-input
        v-model="form.phone"
        placeholder="请输入"
        clearable
      >
      </el-input>
    </el-form-item>
    <el-form-item v-if="form.type !== 2 && form.type !== 3">
      <div slot="label">
        <i class="star">*</i>
        <span>有效期</span>
      </div>
      <!--
          1.如果是添加弹窗，默认选中当天
          2.如果是编辑弹窗，则显示之前的数据
          -->
      <el-row>
        <el-col :span="11">
          <el-form-item
            prop="startTime"
          >
            <el-date-picker
              style="width: 100%;"
              v-model="form.startTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="开始时间"
              :disabled="startdisabled"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <div class="short-thing">至</div>
        </el-col>
        <el-col :span="11">
          <el-form-item
            prop="endTime"
          >
            <el-date-picker
              style="width: 100%;"
              v-model="form.endTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item
      label="推荐人姓名"
    >
      <el-input
        placeholder="选填"
        v-model="form.recommender"
      ></el-input>
    </el-form-item>
    <!--
      生成个数仅超管可见可改(判据见下方 isAdmin)，其余角色按默认值 1 生成。
      每日授权码是 产品编码+日期 算出的确定值，同一天恒定同码，后端拒绝批量。
      -->
    <el-form-item
      v-if="!isEdit && isAdmin && form.type !== 3"
      label="生成个数"
    >
      <el-input-number
        style="width: 100%"
        v-model="form.generateCount"
        :min="1"
        :max="100"
        :step="1"
        step-strictly
      ></el-input-number>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters } from "vuex";
import { isMobile } from "@/utils/validate";
import { init_date } from "@/utils";
let defaultForm = {
  name: '',
  phone: '',
  productType: [],

  startTime: '',
  endTime: '',
  // 平台
  platform: '',
  login: '',
  type:1,
  recommender: '',
  generateCount: 1,
};
import formLabalPosition from "@/mixins/formLabalPosition";
export default {
  name: "authForm",
  props: {
    formData: {
      type: Object,
      default(){
        return {
          name: '',
          phone: '',
          productType: [],
          type:1,
          startTime: '',
          endTime: '',
          // 平台
          platform: '',
          login: '',
          bindMac: '',

          recommender: '',
        }
      }
    },
    productList: {
      type: Array,
      default(){
        return [];
      }
    },
    isEdit: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    let validatePhone = (rule, value, callback) => {
      if(!isMobile(+value)){
        callback(new Error('请输入正确的格式'));
      }else {
        callback();
      }
    };
    return {
      labelWidth: '100px',
      form: JSON.parse(JSON.stringify(defaultForm)),
      rules:{
        name: [
          { required: true, message: '请输入', trigger: 'blur' },
          // { validator: validateName, trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        type: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        endTime: [
          { required: true, message: '请选择', trigger: 'change' },
        ]
      },
      authtypes:[
        {value:1,label:"普通码"},
        {value:2,label:"试用码"},
        {value:3,label:"每日授权码"}
      ]
    }
  },
  watch:{
    formData:{
      handler(newValue){
        if(newValue.id){
          this.assign(newValue);
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 与后端 isSuperAdmin() 对齐：超管角色(role_id=1)，或 userId=1 的 admin 本人——
    // 后者走权限旁路，在 sys_user_role 里不一定有记录，只判角色会把它判成非管理员
    isAdmin() {
      const info = this.userInfo || {};
      return (info.roleIdList || []).some(id => Number(id) === 1) || Number(info.userId) === 1;
    },
    startdisabled() {
      // 添加时不可以修改
      // return !this.isEdit;
      return true;
    },
    // 每日授权码(type===3)时授权产品为单选，其余类型为多选。
    // 内部 form.productType 始终保持为数组，以便提交时统一使用 join(',')。
    productTypeProxy: {
      get() {
        if (this.form.type === 3) {
          return this.form.productType.length ? this.form.productType[0] : '';
        }
        return this.form.productType;
      },
      set(val) {
        if (this.form.type === 3) {
          this.form.productType = val !== '' && val !== null && val !== undefined ? [val] : [];
        } else {
          this.form.productType = val;
        }
      }
    }
  },
  mixins: [formLabalPosition],
  created(){
    if(!this.isEdit){
      this.initDate();
    }
  },
  methods: {
    reset(){
      this.form = JSON.parse(JSON.stringify(defaultForm));
      this.initDate();
    },
    selfClear(){
      this.$refs.form.clearValidate();
      this.reset();
    },
    assign(){
      let numArr = this.formData.authorizedProducts.split(',').map(Number);

      this.form.id = this.formData.id;
      this.form.type = this.formData.type;
      this.form.name = this.formData.userName;
      this.form.phone = this.formData.phone;
      this.form.productType = numArr;
      this.form.startTime = this.formData.beginDate;
      this.form.endTime = this.formData.endDate;
      this.form.platform = this.formData.bindPlatform;
      this.form.login = this.formData.bindLogin;
      this.form.bindMac = this.formData.bindMac; //新加的 todo
      this.form.recommender = this.formData.referrer;
    },
    selfValidate(){
      // 试用码和每日授权码不需要校验有效期
      if(this.form.type === 2 || this.form.type === 3){
        this.rules.endTime[0].required = false;
      } else {
        this.rules.endTime[0].required = true;
      }
      // 每日授权码不需要校验客户姓名和手机
      if(this.form.type === 3){
        this.rules.name[0].required = false;
        this.rules.phone[0].required = false;
      } else {
        this.rules.name[0].required = true;
        this.rules.phone[0].required = true;
      }
      this.$nextTick(() => {
        this.$refs.form.validate((valid) => {
          if(valid){
            this.$emit('submit',this.form);
          }else {
            console.log('no-pass');
          }
        })
      });
    },
    initDate(){

      let dateInfo = init_date();
      // this.endTime = dateInfo.oneMonAgo;
      this.form.startTime = dateInfo.today;
    },
    typechange(val){
      if(val == 2){
         // 试用码
        if(this.form.startTime&&this.form.startTime !=""){
            this.form.endTime = this.getNextMonthDate(this.form.startTime);
        }
      }
      if(val == 2 || val == 3){
        // 试用码和每日授权码不需要有效期
        this.form.endTime = '';
      }
      if(val == 3){
        // 每日授权码授权产品限制为单选，保留首个已选产品
        if(Array.isArray(this.form.productType) && this.form.productType.length > 1){
          this.form.productType = [this.form.productType[0]];
        }
        // 该档不支持批量，切过来时归位，避免带着已设的个数提交被后端拒绝
        this.form.generateCount = 1;
      }
    },
    getNextMonthDate(dateStr) {
        // 解析输入日期
        const [year, month, day] = dateStr.split('-').map(Number);
        const originalDate = new Date(year, month - 1, day); // 月份从0开始

        // 计算下个月的年份和月份
        const nextMonthDate = new Date(originalDate);
        nextMonthDate.setMonth(originalDate.getMonth() + 1);

        // 获取下个月的信息
        const nextYear = nextMonthDate.getFullYear();
        const nextMonth = nextMonthDate.getMonth();

        // 计算下个月的最后一天
        const lastDayOfNextMonth = new Date(nextYear, nextMonth + 1, 0).getDate();

        // 确定正确的日期
        const adjustedDay = Math.min(day, lastDayOfNextMonth);

        // 构造结果日期并格式化
        const resultDate = new Date(nextYear, nextMonth, adjustedDay);
        const formattedDate = [
          resultDate.getFullYear(),
          String(resultDate.getMonth() + 1).padStart(2, '0'),
          String(resultDate.getDate()).padStart(2, '0')
        ].join('-');
        return formattedDate;
      }


    // setOptionWidth(event){
    //   this.$nextTick(()=>{
    //     document.querySelector('.specialSelect').style.maxWidth = event.srcElement.offsetWidth + "px";
    //   })
    // }
  },
}
</script>

<style lang="scss" scoped>
.auth-form {
  .star {
    color: #F56C6C;
    padding-right: 5px;
  }
}
</style>
<style lang="scss">
.auth-form {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .short-thing {
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
}



// 移动端样式
@media screen and (max-width: 768px){
  .auth-form {
    .el-form-item__label {
      float: none;
      display: block;
      width: 100%!important;
      padding: 0 0 8px;
      text-align: left;
      line-height: 1.4;
    }
    .el-form-item__content {
      margin-left: 0!important;
    }
    .el-row {
      display: flex;
      flex-direction: column;
    }
    .el-col-11,
    .el-col-2 {
      width: 100%;
    }
    .short-thing {
      height: 28px;
      line-height: 28px;
      text-align: left;
    }
  }
  .specialSelect{
    .el-select-dropdown__item{
      height: auto;
      max-width: 350px;
      white-space: normal;
    }
  }
}
</style>
